import wixData from 'wix-data';
import wixLocation from 'wix-location';
import { v4 as uuidv4 } from 'uuid';
import Fuse from 'fuse.js';

const COLOR_HIGHLIGHT = "#EEEEEE"; // Beige
const COLOR_REGULAR = "#FFFFFF"; // white

const currentPage = wixLocation.path[0];
let selectedSearchItem;

if (currentPage === "verkaufen") {
    $w('#searchInput').collapse();
    $w('#searchBtn').collapse();
} else {
    $w('#searchInput').expand();
    $w('#searchBtn').expand();
}

$w.onReady(async function () {

    let queryCollection = ''; // Variable to store the collection name for querying
    let queryLimit = 3; // Default query limit

    console.log('current page', currentPage);

    if (currentPage === 'autoren') {
        queryCollection = 'Authors';
        queryLimit = 5;
    } else if (currentPage === 'buchreihen') {
        queryCollection = 'Product_Details';
        queryLimit = 5;
    } else if (currentPage === 'genres') {
        queryCollection = 'Genres';
        queryLimit = 5;
    } else {
        queryCollection = 'Product_Details';
        queryLimit = 5;
    }
    
    // Search input onKeyPress
    $w('#searchInput').onKeyPress(async (event) => {
        setTimeout(async () => {
            if ($w('#searchInput').value.length === 0) {
                $w("#dropdownRepeater").collapse()
                    .then(() => {
                        $w("#noResultsTxt").collapse();
                    });
            } else {
                const inputValue = $w('#searchInput').value;
                $w("#searchResetBtn").show();
                let collectionData = [];
                let expandNoResultsTxt = false; // Flag to determine whether to expand #noResultsTxt
                
                
                // Static items for BUCHREIHEN, AUTOREN, and GENRE
                if (queryCollection === 'Product_Details' || currentPage === undefined) {

                    // Step 1: Fetch all data from the collection with pagination
                    let results = await wixData.query("Product_Details").fields("author", "products", "title", "price", "producturl").limit(1000).find();
                    let allItems = results.items;

                    // Keep fetching if there are more pages of data
                    while (results.hasNext()) {
                        results = await results.next();
                        allItems = allItems.concat(results.items);
                    }

                    // Step 2: Fuzzy search using Fuse.js for author and products fields
                    const fuseOptions = {
                        keys: ['author', 'products'],  // Search on author and products fields
                        threshold: 0.3, // Adjust sensitivity for fuzzy matching
                    };

                    // Initialize Fuse.js with the full data set
                    const fuse = new Fuse(allItems, fuseOptions);

                    // Step 3: Perform the fuzzy search
                    const searchResult = fuse.search(inputValue);  // Perform search based on user input

                    // Step 4: Return the result, mapping to the original data items
                    const fuzzy = searchResult.map(result => result.item);

                    // Limit to 5 results
                    const limitedFuzzyResults = fuzzy.slice(0, 5);  // Limit to 5 results

                    console.log("Fuzzy search", limitedFuzzyResults);

                    // Static category headers
                    const autorenItems = { _id: 'autorenItems', title: "AUTOREN", category: 'AUTOREN' };

                    // Add unique authors to collectionData
                    if (limitedFuzzyResults.length) {
                        const uniqueAuthors = [];

                        limitedFuzzyResults.forEach(item => {
                            if (!uniqueAuthors.some(author => author.author === item.author)) {
                                uniqueAuthors.push(item);
                            }
                        });

                        collectionData.push(autorenItems, ...uniqueAuthors.map(item => ({
                            ...item,
                            category: 'AUTOREN',
                            _id: uuidv4(), // New unique ID
                            itemId: item._id // Store original _id as itemId
                        })));
                    }

                    // BUCHREIHEN category
                    const buchreihenItems = { _id: 'buchreihenItems', title: "BUCHREIHEN", category: 'BUCHREIHEN' };

                    // Step 1: Fuzzy search for 'title' and 'author' for BUCHREIHEN category
                    const fuseOptionsBuchreihen = {
                        keys: ['title', 'author', 'title'],  // Search on title and author fields for BUCHREIHEN
                        threshold: 0.3, // Adjust sensitivity for fuzzy matching
                    };

                    // Initialize Fuse.js with the full data set for BUCHREIHEN
                    const fuseBuchreihen = new Fuse(allItems, fuseOptionsBuchreihen);

                    // Step 2: Perform the fuzzy search for BUCHREIHEN
                    const searchResultBuchreihen = fuseBuchreihen.search(inputValue);  // Perform search based on user input for BUCHREIHEN

                    // Step 3: Return the result, mapping to the original data items for BUCHREIHEN
                    const fuzzyBuchreihen = searchResultBuchreihen.map(result => result.item);

                    // Limit to 5 results for BUCHREIHEN
                    const limitedFuzzyBuchreihenResults = fuzzyBuchreihen.slice(0, 5);  // Limit to 5 results

                    console.log("Fuzzy search for BUCHREIHEN", limitedFuzzyBuchreihenResults);

                    // Add unique Buchreihen to collectionData
                    if (limitedFuzzyBuchreihenResults.length) {
                        const uniqueBuchreihen = [];

                        limitedFuzzyBuchreihenResults.forEach(item => {
                            if (!uniqueBuchreihen.some(series => series.title === item.title)) {
                                uniqueBuchreihen.push(item);
                            }
                        });

                        collectionData.push(buchreihenItems, ...uniqueBuchreihen.map(item => ({
                            ...item,
                            category: 'BUCHREIHEN',
                            _id: uuidv4(), // New unique ID
                            itemId: item._id // Store original _id as itemId
                        })));
                    }

                    const bookTitleItems = { _id: 'bookTitleItems', title: "BUCHTITEL", category: 'BUCHTITEL' };

                    // Step 1: Extract unique book names and map them to objects with original properties
                    const bookNameObjects = allItems.flatMap(item => {
                        const bookNames = item.products ? item.products.split('|').map(name => name.trim()) : [];

                        return bookNames.map(bookName => ({
                            ...item,
                            products: bookName, // Store individual book name
                            _id: uuidv4(), // Unique ID for each book name
                            itemId: item._id, // Reference to original item
                            category: 'BUCHTITEL'
                        }));
                    });

                    // Step 2: Fuzzy search using Fuse.js
                    const fuseOptionsBookTitle = {
                        keys: ['products', 'author'],
                        threshold: 0.3,
                    };

                    const fuseBookTitle = new Fuse(bookNameObjects, fuseOptionsBookTitle);
                    const searchResultBookTitle = fuseBookTitle.search(inputValue);

                    // Step 3: Extract unique book names and limit to 5
                    const uniqueBookTitles = [];
                    const uniqueTitlesSet = new Set();

                    for (const result of searchResultBookTitle) {
                        const { products } = result.item;
                        if (!uniqueTitlesSet.has(products) && uniqueBookTitles.length < 5) {
                            uniqueTitlesSet.add(products);
                            uniqueBookTitles.push(result.item);
                        }
                    }

                    console.log("Fuzzy search for BUCHTITEL", uniqueBookTitles);


                    // Add the static category header and unique book titles to collectionData
                    if (uniqueBookTitles.length) {
                        collectionData.push(bookTitleItems, ...uniqueBookTitles);
                    }

                } else if (queryCollection === 'Authors') {
                    const { items: authorsResults } = await wixData.query(queryCollection)
                        .contains('title', inputValue)
                        .or(wixData.query(queryCollection).contains("authorText", inputValue))
                        .ascending("title")
                        .limit(queryLimit)
                        .find();

                    // Create static GENRE item if there are results for Authors query
                    if (authorsResults.length !== 0) {
                        const autorenItems = { _id: 'autorenItems', title: "AUTOREN" };
                        collectionData.push(autorenItems);
                        collectionData = collectionData.concat(authorsResults);
                    }
                } else if (queryCollection === 'Genres') {
                    const { items: genreResults } = await wixData.query(queryCollection)
                        .contains('title', inputValue)
                        .ascending("title")
                        .limit(queryLimit)
                        .find();

                    // Check if there are results for Genre query
                    if (genreResults.length !== 0) {
                        const genreItems = { _id: 'genreItems', title: "GENRE" };
                        collectionData.push(genreItems);
                        collectionData = collectionData.concat(genreResults);
                    }
                } else {
                    /*
                    // Query all collections separately without limit and contains
                    const queryProductDetails = wixData.query('Product_Details').descending('bestseller');
                    const queryAuthors = wixData.query('Authors').ascending('title');
                    const queryGenres = wixData.query('Genres').ascending('title');

                    // Fetch all data from each collection
                    const resultsProductDetails = await fetchAllData(queryProductDetails);
                    const resultsAuthors = await fetchAllData(queryAuthors);
                    const resultsGenres = await fetchAllData(queryGenres);

                    console.log('resultsProductDetails', resultsProductDetails)

                    // Combine all fetched data into one array
                    let allItems = [...resultsProductDetails, ...resultsAuthors, ...resultsGenres];

                    //console.log('allItems', allItems)

                    // Fuse.js options for fuzzy search
                    const fuseOptions = {
                        keys: ['title', 'products', 'authorText'], // Adjust fields based on your data
                        threshold: 0.3, // Adjust sensitivity for fuzzy matching
                    };

                    // Initialize Fuse.js with the combined dataset
                    const fuse = new Fuse(allItems, fuseOptions);

                    // Perform the fuzzy search based on user input
                    const searchResult = fuse.search(inputValue);

                    // Map search results back to original items
                    const fuzzy = searchResult.map(result => result.item);

                    console.log('fuzzy', fuzzy)

                    // Static category headers
                    const buchreihenItems = { _id: 'buchreihenItems', title: "BUCHREIHEN" };
                    const autorenItems = { _id: 'autorenItems', title: "AUTOREN" };
                    const genreItems = { _id: 'genreItems', title: "GENRE" };

                    // Organize the data to group static items with their respective results
                    let collectionData = [];

                    if (resultsProductDetails.length !== 0) {
                        collectionData.push(buchreihenItems, ...resultsProductDetails);
                    }
                    if (resultsAuthors.length !== 0) {
                        collectionData.push(autorenItems, ...resultsAuthors);
                    }
                    if (resultsGenres.length !== 0) {
                        collectionData.push(genreItems, ...resultsGenres);
                    }

                    // Add fuzzy search results to the collection data
                    if (fuzzy.length !== 0) {
                        collectionData.push(...fuzzy);
                    }

                    // Limit to 5 results
                    //const limitedResults = collectionData.slice(0, 5);

                    // Update the flag based on the results
                    expandNoResultsTxt = (collectionData.length === 0);

                    console.log("collectionData:", collectionData);
                    */



                    /*
                    // Query all collections separately and merge the results
                    const queryProductDetails = wixData.query('Product_Details')
                        .contains('title', inputValue)
                        .or(wixData.query(queryCollection).contains("products", inputValue))
                        .descending("bestseller")
                        .limit(queryLimit)
                        
                    const queryAuthors = wixData.query('Authors')
                        .contains('title', inputValue)
                        .or(wixData.query('Authors').contains("authorText", inputValue))
                        .ascending("title")
                        .limit(queryLimit)

                    const queryGenres = wixData.query('Genres')
                        .contains('title', inputValue)
                        .ascending("title")
                        .limit(queryLimit)

                    const { items: resultsProductDetails } = await queryProductDetails.find();
                    const { items: resultsAuthors } = await queryAuthors.find();
                    const { items: resultsGenres } = await queryGenres.find();

                    // Static items for all categories when querying all collections
                    const buchreihenItems = { _id: 'buchreihenItems', title: "BUCHREIHEN" };
                    const autorenItems = { _id: 'autorenItems', title: "AUTOREN" };
                    const genreItems = { _id: 'genreItems', title: "GENRE" };

                    // Organize the data to group static items with their respective results
                    if (resultsProductDetails.length !== 0) {
                        collectionData.push(buchreihenItems, ...resultsProductDetails);
                    }
                    if (resultsAuthors.length !== 0) {
                        collectionData.push(autorenItems, ...resultsAuthors);
                    }
                    if (resultsGenres.length !== 0) {
                        collectionData.push(genreItems, ...resultsGenres);
                    }
                    // Update the flag based on the results
                    expandNoResultsTxt = (collectionData.length === 0)
                    */
                }

                

                // Expand or collapse results based on the flag
                if (expandNoResultsTxt) {
                    $w("#dropdownRepeater").collapse();
                    $w("#noResultsTxt").expand();
                } else {
                    $w("#noResultsTxt").collapse();
                    $w('#dropdownRepeater').data = collectionData;
                    console.log("Collection data", collectionData);
                    $w('#dropdownRepeater').expand();
                }
            }
        }, 50);
    });

    // Function to fetch all data from a collection
    async function fetchAllData(query) {
        let results = await query.find();
        let allItems = results.items;

        while (results.hasNext()) {
            results = await results.next();
            allItems = allItems.concat(results.items);
        }

        return allItems;
    }
});



export function dropdownRepeater_itemReady($item, itemData, index) {
    const categoryItems = itemData._id === 'autorenItems' || itemData._id === 'buchreihenItems' || itemData._id === 'genreItems' || itemData._id === 'bookTitleItems';

    const buchreihenCategory = itemData['producturl'];      // Product_details collection
    const autorenCategory = itemData['link-authors-title']; // Authors collection
    const genreCategory = itemData['link-genres-1-title'];  // Genre collection
    //const bookTitleCategory = itemData['producturl'];   // Product_details collection
    
    // Display title based on category
    if (itemData.category === 'BUCHTITEL') {
        // Show category name (BUCHTITEL) for the header
        if (itemData._id === 'bookTitleItems') {
            $item('#title').label = itemData.title;  // Display category name (e.g., "BUCHTITEL") for the header
        } else {
            // Display products for items below the category header
            $item('#title').label = itemData.products;
        }
    } else if (itemData.category === 'AUTOREN') {
        // Show category name (AUTOREN) for the header
        if (itemData._id === 'autorenItems') {
            $item('#title').label = itemData.title;
        } else {
            // Display author for items below the category header
            $item('#title').label = itemData.author;
        }
    } else {
        // For other categories, display the title as usual
        $item('#title').label = itemData.title;
    }


    // Change item background color on mouse hover interaction
    if (!categoryItems) {
        $item("#searchItem").onMouseIn(() => {
            $item("#itemContainerBox").style.backgroundColor = COLOR_HIGHLIGHT;
        });
        $item("#searchItem").onMouseOut(() => {
            $item("#itemContainerBox").style.backgroundColor = COLOR_REGULAR;
        });
    }

    // Disable search category items (autoren, buchreihen, genre, bookTitle)
    if (categoryItems) {
        console.log(categoryItems);
        $item('#title').disable();
        $item('#info').hide();
        return;  // Don't process further if the item is part of the category items
    }

    if (itemData.category === "BUCHREIHEN") {
        $item('#info').label = `${itemData.price}€`;
    } else if (itemData.category === "AUTOREN") {
        $item('#info').label = "";
    } else if (itemData.category === "BUCHTITEL") {
        $item('#info').label = "";
    } else {
        $item('#info').label = itemData.newField1 || (itemData.price !== undefined ? `${String(itemData.price)}€` : '');
    }
   
    // Handle the dropdown item click based on the category and current page
    $item('#searchItem').onClick(() => {
        // Check if the current page is HOME PAGE
        if (currentPage !== 'buchreihen' && currentPage !== 'autoren' && currentPage !== 'genres') {
        
            if (itemData.category === "AUTOREN") {
                selectedSearchItem = itemData.author;
            } else {
                selectedSearchItem = itemData.title;
            }

            console.log("selectedSearchItem", selectedSearchItem);

            if (selectedSearchItem.length > 0) {
                const encodedSearchPhrase = encodeURIComponent(selectedSearchItem);
                const url = "/buchreihen?search=" + encodedSearchPhrase + "&category=" + encodeURIComponent(itemData.category);
                insertSearchTerm(selectedSearchItem)
                    .then(() => {
                        console.log("Search term inserted successfully");
                        // Redirect to the URL
                        wixLocation.to(url);
                    })
                    .catch((err) => {
                        console.error("Error inserting search term:", err);
                    });
            }   


            /*
            $w('#searchInput').value = itemData.title;

            // Check the category and assign the link
            let externalLink = "";
            if (buchreihenCategory) {
                externalLink = "https://www.buecherpakete.at" + buchreihenCategory;
            } else if (autorenCategory) {
                externalLink = autorenCategory;
            } else if (genreCategory) {
                externalLink = genreCategory;
            }

            // Insert search term to collection and then redirect
            insertSearchTerm(itemData.title)
                .then(() => {
                    wixLocation.to(externalLink);
                })
                .catch((error) => {
                    console.error("Error inserting search term:", error);
                    // Redirect even if there's an error inserting the search term
                    wixLocation.to(externalLink);
                });
            */
        } else {
            insertSearchTerm(itemData.title);
        }
    });
}



/*
export function dropdownRepeater_itemReady($item, itemData, index) {

    const categoryItems = itemData._id === 'buchreihenItems' || itemData._id === 'autorenItems' || itemData._id === 'genreItems' || itemData._id === 'bookTitleItems';

    const buchreihenCategory = itemData['producturl'];      // Product_details collection
    const autorenCategory = itemData['link-authors-title']; // Authors collection
    const genreCategory = itemData['link-genres-1-title'];  // Genre collection
    const bookTitleCategory = itemData['producturl'];  // Book title 
    
    $item('#title').label = itemData.product;

    // Change item background color on mouse hover interaction
    if (!categoryItems) {
        $item("#searchItem").onMouseIn(() => {
            $item("#itemContainerBox").style.backgroundColor = COLOR_HIGHLIGHT;
        });
        $item("#searchItem").onMouseOut(() => {
            $item("#itemContainerBox").style.backgroundColor = COLOR_REGULAR;
        });
    }

    // Disable search category items
    if (categoryItems) {
        $item('#title').disable();
        $item('#info').hide();
        return;
    }

    // Show info text based on cateogry
    if (buchreihenCategory) {
        $item('#info').label = `${itemData.price}€`;
    }
    if (autorenCategory) {
        $item('#info').label = itemData.newField1;
    }
    if (genreCategory) {
        $item('#info').hide();
    }
    if (bookTitleCategory) {
        $item('#info').hide();
    }
    
    // Handle the dropdown item click based on the category and current page
    $item('#searchItem').onClick(() => {
        // Check if the current page is not "buchreihen," "autoren," or "genres"
        if (currentPage !== 'buchreihen' && currentPage !== 'autoren' && currentPage !== 'genres') {
            $w('#searchInput').value = itemData.title;

            // Check the category and assign the link
            let externalLink = "";
            if (buchreihenCategory) {
                externalLink = "https://www.buecherpakete.at" + buchreihenCategory;
            } else if (autorenCategory) {
                externalLink = autorenCategory;
            } else if (genreCategory) {
                externalLink = genreCategory;
            }

            // Insert search term to collection and then redirect
            insertSearchTerm(itemData.title)
                .then(() => {
                    wixLocation.to(externalLink);
                })
                .catch((error) => {
                    console.error("Error inserting search term:", error);
                    // Redirect even if there's an error inserting the search term
                    wixLocation.to(externalLink);
                });
        } else {
            insertSearchTerm(itemData.title);
        }
    });
}
*/

// Function to insert search term to collection
function insertSearchTerm(searchTerm) {
    const searchData = {
        searchPhrase: searchTerm,
        searchBar: "Kaufen"  // Add your additional field here
    };

    return wixData.insert("SearchQueries", searchData);
}

// Search button click event
export function searchBtn_click(event) {
    const phrase = $w("#searchInput").value;
    // Check if the current page is not "buchreihen," "autoren," or "genres"
    if (currentPage !== 'buchreihen' && currentPage !== 'autoren' && currentPage !== 'genres') {
            selectedSearchItem = $w("#searchInput").value;
            console.log("selectedSearchItem", selectedSearchItem);

            if (selectedSearchItem.length > 0) {
                const encodedSearchPhrase = encodeURIComponent(selectedSearchItem);
                const url = "/buchreihen?search=" + encodeURIComponent(encodedSearchPhrase) + "&searchBtn=" + encodeURIComponent("true");
                insertSearchTerm(selectedSearchItem)
                    .then(() => {
                        console.log("Search term inserted successfully");
                        // Redirect to the URL
                        wixLocation.to(url);
                    })
                    .catch((err) => {
                        console.error("Error inserting search term:", err);
                    });
            }   

        /*

        const phrase = $w("#searchInput").value;

        if (phrase.trim() === "") {
        return;
        }
        const formatPhrase = phrase.toLowerCase();
        let searchWords = formatPhrase.split(' ');
        if (searchWords.length > 0) {
            const searchPhrase = $w("#searchInput").value;
            const encodedSearchPhrase = encodeURIComponent(searchPhrase);
            const url = "/buchreihen?search=" + encodedSearchPhrase;
            insertSearchTerm(searchPhrase)
                .then(() => {
                    console.log("Search term inserted successfully");
                    // Redirect to the URL
                    wixLocation.to(url);
                })
                .catch((err) => {
                    console.error("Error inserting search term:", err);
                });
        }   
        */
    } else {
        insertSearchTerm(phrase);
    }
}

// Search input reset button
export function searchResetBtn_click(event) {
    // Check if the current page is not "buchreihen," "autoren," or "genres"
    if (currentPage !== 'buchreihen' && currentPage !== 'autoren' && currentPage !== 'genres') {
        $w("#searchResetBtn").hide();
        $w("#searchInput").value = "";
        $w("#dropdownRepeater").collapse();
        $w("#noResultsTxt").collapse();
    }
}